import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminChannelsView = () => import('@/views/admin/ChannelsView.vue');
export const NAME_ADMIN_CHANNELS = 'AdminChannels';
export const PATH_ADMIN_CHANNELS = 'channels';

export const route: DiscoveredRouteModule = {
  id: 'admin.channels',
  scope: 'admin',
  moduleKey: 'channels',
  name: NAME_ADMIN_CHANNELS,
  path: PATH_ADMIN_CHANNELS,
  component: AdminChannelsView,
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'project_channels', 'portal_base'] },
};
